import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { queryClientState } from "../../context/queryClientState";
import { swapRateState } from "../../context/swapRateState";
import { swapState } from "../../context/swapState";
import { useConfig } from "../../hooks/useConfig";
import { useRoute } from "../../hooks/useRoute";

const SwapRate = ({ denom1, denom2 }: { denom1: string; denom2: string }) => {
  const [rate, setRate] = useState("");
  const [swap, setSwap] = useState(false);
  const { getSwapRate } = useRoute();
  const { queryClient } = useRecoilValue(queryClientState);
  const swapRateData = useRecoilValue(swapRateState);
  const swapData = useRecoilValue(swapState);
  const setSwapRateData = useSetRecoilState(swapRateState);

  useEffect(() => {
    fetchPrices();
  // }, [swapData.input1, denom1, denom2, queryClient]);
  }, [swapData.input1, denom1, denom2]);

  //try tremoving input2 from swapData

  const fetchPrices = useCallback(async () => {
    let newRate: {tokenPath: string[], outputAmount: string};
    if (Number(swapData.input1) > 0)
      newRate = await getSwapRate(denom1, denom2, swapData.input1);
    else newRate = await getSwapRate(denom1, denom2, "1");
    if (newRate === undefined) {
      newRate = {
        tokenPath: [],
        outputAmount: "1",
      };
    }

    const input2 = !Number(swapData.input1)
    ? ""
    : // : (Number(swapData.input1) * Number(newRate)).toString();
    Number(newRate.outputAmount).toString();
    
    const finalrate = Number(swapData.input1)
                ? (Number(newRate.outputAmount) / Number(swapData.input1)).toFixed(5)
                : newRate.outputAmount
    setRate(finalrate as string);

    setSwapRateData({
      ...swapRateData,
      input2: input2,
      swapRate: newRate.outputAmount as string,
      tokenPath: newRate.tokenPath,
    });
  }, [denom1, denom2, queryClient, swapData.input1]);

  return (
    <div className="swap-rate-container">
      <div>PRICE</div>
      <div className="swap-rate-switch">
        {!swap ? (
          <>
            <span className="numeric-font">
              {rate}
            </span>{" "}
            {denom2} per {denom1}
          </>
        ) : (
          <>
            <span className="numeric-font">
              {(1/Number(rate)).toFixed(4)}
            </span>{" "}
            {denom1} per {denom2}
          </>
        )}
        <div className="swap-rate-switch-icon" onClick={() => setSwap(!swap)}>
          <FontAwesomeIcon icon={faRightLeft} />
        </div>
      </div>
    </div>
  );
};

export default SwapRate;
